// Slide copy for the signup brand panel carousels.

export type SignupAgentSlide =
  | { graphic: "miniapps" }
  | {
      title: string;
      description: string;
      graphic:
        | "integrations"
        | "context"
        | "domains"
        | "selectEdit"
        | "insights";
    };

export type SignupShopifySlide = {
  title: string;
  description: string;
  graphic: "editor" | "templates" | "content" | "publish";
};

export const signupAgentSlides: SignupAgentSlide[] = [
  { graphic: "miniapps" },
  {
    title: "Put your store data to work",
    description:
      "Connect your store, reviews, and email tools to create campaigns using your products and customer feedback.",
    graphic: "integrations",
  },
  {
    title: "Keep every page on brand",
    description:
      "Add your logos, colors, products, and images once. Use them across new pages and campaigns.",
    graphic: "context",
  },
  {
    title: "Launch on your own domain",
    description:
      "Publish pages on your own domain so customers recognize your brand.",
    graphic: "domains",
  },
  {
    title: "Edit your store by describing the change",
    description:
      "Describe a new page or select something to change. Preview the result before you publish.",
    graphic: "selectEdit",
  },
  {
    title: "Turn data into next steps",
    description:
      "See where shoppers drop off and which campaigns bring sales, then choose what to improve.",
    graphic: "insights",
  },
];

export const signupShopifySlides: SignupShopifySlide[] = [
  {
    title: "Drag-and-drop page builder",
    description:
      "Drop sections into place, then adjust layout, spacing, and styles from the builder panel.",
    graphic: "editor",
  },
  {
    title: "Start from sections and templates",
    description:
      "Use ready-made layouts for landing pages, PDPs, collections, and campaign pages, then customize them for the brand.",
    graphic: "templates",
  },
  {
    title: "Use dynamic Shopify data",
    description:
      "Connect products, images, prices, and reviews with dynamic data so the page stays accurate as Shopify changes.",
    graphic: "content",
  },
  {
    title: "Publish to your Shopify theme",
    description:
      "Send finished pages into the theme your store already uses, with a preview of what will go live before customers see it.",
    graphic: "publish",
  },
];
